import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ElementRef,
} from '@angular/core'
import {Subscription} from 'rxjs/Subscription'
import {GalleryService} from '../../../ui-shared/gallery/gallery.service'
import {FolderService} from '../../folder.service'
import * as moment from 'moment'

const BREAKPOINTS = [/*920, 765, */ 610, 455, 300, 145]
const MASONRY_SETTINGS = {
  columnWidth: 145,
  gutter: 10,
  transitionDuration: 0,
}

declare var Masonry: any

@Component({
  selector: 'app-folder-view-grid',
  templateUrl: './folder-view-grid.component.html',
  styleUrls: ['./folder-view-grid.component.scss'],
})
export class FolderViewGridComponent implements OnInit {
  @Input() folder: any
  breakpoints: Array<number> = BREAKPOINTS
  masonry: any
  subscription: Subscription

  constructor(
    public gallery: GalleryService,
    public folderService: FolderService,
    private elRef: ElementRef
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.refreshMasonry()

    if (this.folder && this.folder.subject) {
      this.subscription = this.folder.subject.asObservable().subscribe(() => {
        this.refreshMasonry()
      })
    }
  }

  refreshMasonry() {
    if (
      this.folder &&
      this.folder.filtered_files_array &&
      this.folder.filtered_files_array.length
    ) {
      this.masonryExceptions()
    }

    if (
      !document.querySelector('#filelist') ||
      !this.folder.filtered_files_array.length
    )
      return
    this.masonry = new Masonry('#filelist', MASONRY_SETTINGS)
    setTimeout(() => {
      this.masonry = new Masonry('#filelist', MASONRY_SETTINGS)
    }, 50)
    setTimeout(() => {
      this.masonry.layout()
    }, 200)
  }

  masonryExceptions() {
    // let sizes = this.folder.filtered_files_array
    // .reduce((prev, curr) => {
    //	 let width = curr.name.match(/\d+x\d+/) ? curr.name.match(/\d+x\d+/)[0].split('x')[0] : 300
    //	 return [...prev, ...width]
    // }, [])
    // .map(a => this.getDisplayWidth(a))
    // .filter((v, i, a) => a.indexOf(v) === i)

    // if (sizes.length == 1) {
    // Make sure it will fill the screen
    let rect = this.elRef.nativeElement.parentElement.getBoundingClientRect()
    switch (rect.width) {
      case 300: // 2
        this.breakpoints = [300, 145, 0]
        break
      case 455: // 3
        this.breakpoints = [455, 145]
        break
      case 610: // 4
        this.breakpoints = [610, 300, 145]
        break
      case 765: // 5
        this.breakpoints = [765, 300, 145]
        break
      case 920: // 6
        this.breakpoints = [920, 455, 300, 145]
        break
      case 1075: // 7
        this.breakpoints = [1075, 300, 145]
        break
      case 1230: // 8
        this.breakpoints = [610, 300, 145]
        break
      default:
        this.breakpoints = BREAKPOINTS
    }
    // } else {
    //	 this.breakpoints = BREAKPOINTS
    // }
  }

  getDisplayWidth(realWidth) {
    // let windowWidth = this.getWindowSize().width
    // let width = realWidth > windowWidth ? windowWidth : realWidth
    let rect = this.elRef.nativeElement.parentElement.getBoundingClientRect()
    let width = realWidth > rect.width ? rect.width : realWidth
    for (var i = 0; i < this.breakpoints.length - 1; i++) {
      if (width >= this.breakpoints[i]) return this.breakpoints[i]
    }
    return width > this.breakpoints[this.breakpoints.length - 1]
      ? this.breakpoints[this.breakpoints.length - 1]
      : width
  }

  open(event, index: number) {
    let window_width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      window_width <= 768
    )
      // is Mobile
      return true
    event.preventDefault()
    this.gallery.open(index)
    return false
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-grid/folder-view-grid.component.ts